import React, { useState } from 'react';
import { HeartCanvas } from '../components/HeartCanvas';
import { ViewerControls } from '../components/ViewerControls';
import { Countdown } from '../components/Countdown';
import { useHeartContent } from '../hooks/useHeartContent';

export const HeartPage: React.FC = () => {
  const { data, isLoading, error, seed, reload, rearrange } = useHeartContent();
  const [isHoveringPhrase, setIsHoveringPhrase] = useState(false);

  if (isLoading) {
    return (
      <div className="heart-loading-screen" role="status" aria-label="Loading heart keepsake">
        <div className="subtle-spinner" />
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className="heart-error-screen" role="alert">
        <div className="error-card">
          <p className="error-text">{error || 'Unable to load keepsake content'}</p>
          <button type="button" className="action-btn action-btn-secondary" onClick={reload}>
            Retry
          </button>
        </div>
      </div>
    );
  }

  const showCountdown =
    (data.settings.countdown_visibility === 'heart' || data.settings.countdown_visibility === 'both') &&
    Boolean(data.settings.countdown_target);

  return (
    <main className={`page-heart ${showCountdown ? 'has-countdown' : ''}`} role="main">
      <ViewerControls
        allowRearrange={data.settings.allow_viewer_rearrange}
        onRearrange={rearrange}
        chatVisibility={data.settings.chat_history_visibility}
      />

      <div className="heart-viewport">
        <HeartCanvas
          phrases={data.phrases}
          settings={data.settings}
          seed={seed}
          onPhraseHover={setIsHoveringPhrase}
        />

        {showCountdown && (
          <Countdown
            target={data.settings.countdown_target}
            title={data.settings.countdown_title}
            variant="heart"
            className={isHoveringPhrase ? 'countdown-dimmed' : ''}
          />
        )}
      </div>
    </main>
  );
};
